/* ============================================================
   MOTHER'S DAY 2026 — Quiz: "Чи добре ти знаєш свою маму?"
   ============================================================ */
(function () {
  'use strict';

  // ─── Config ─────────────────────────────────────────────────
  var QUESTIONS = [
    'Я знаю, ким мама мріяла стати в дитинстві',
    'Я можу назвати її улюблений фільм',
    'Я знаю, як звали її найкращу подругу зі школи',
    'Я знаю, чим вона пишається в собі найбільше',
    'Я знаю, чого вона боїться',
    'Я пам\u0027ятаю останній раз, коли ми довго сміялися разом',
    'Я знаю, що вона любить робити, коли в неї є час лише для себе',
    'Я можу назвати книгу, яку вона любить перечитувати',
    'Я знаю, про що вона мріє зараз',
    'Я знаю, що в моєму житті робить її щасливою'
  ];

  var TIERS = [
    {
      min: 0, max: 3,
      message: 'Сьогодні гарний день, щоб запитати. Подзвони мамі\u00A0— їй буде дуже приємно почути твій голос.',
      code: 'MOTHERSDAY15',
      discount: 'знижка 15%'
    },
    {
      min: 4, max: 7,
      message: 'Ти знаєш чимало. Але є ще про що поговорити\u00A0— спробуй сьогодні.',
      code: 'MOTHERSDAY15',
      discount: 'знижка 15%'
    },
    {
      min: 8, max: 10,
      message: 'Ти добре знаєш свою маму. Не забудь сьогодні сказати їй, як сильно ти її цінуєш.',
      code: 'MOTHERSDAY15',
      discount: 'знижка 15%'
    }
  ];

  var REMINDERS = [
    'Напиши мамі прямо зараз 💌',
    'Подзвони мамі — вона чекає 📞',
    'Скажи мамі «люблю» сьогодні 💛',
    'Обійми маму при зустрічі 🤗'
  ];

  var PROMO_DATES = 'діє 9–10 травня';
  var STORAGE_KEY = 'mamaQuiz2026';

  // ─── State ──────────────────────────────────────────────────
  var currentQ = 0;
  var score = 0;
  var quizDone = false;

  // Load state
  try {
    var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved && saved.done) {
      quizDone = true;
      score = saved.score || 0;
    }
  } catch (e) {}

  // ─── DOM helpers ────────────────────────────────────────────
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function getTier(s) {
    for (var i = 0; i < TIERS.length; i++) {
      if (s >= TIERS[i].min && s <= TIERS[i].max) return TIERS[i];
    }
    return TIERS[0];
  }

  // ─── Modal ──────────────────────────────────────────────────
  var modal = null;
  var card = null;

  function createModal() {
    modal = el('div', 'mama-modal mama-modal--hidden');
    card = el('div', 'mama-card');

    var close = el('button', 'mama-close', '×');
    close.onclick = function () {
      try { localStorage.setItem(STORAGE_KEY + '_seen', '1'); } catch (e) {}
      hideModal();
    };
    card.appendChild(close);

    // Квіти в кутках
    var corners = [
      { cls: 'mama-corner mama-corner--tl', txt: '✿' },
      { cls: 'mama-corner mama-corner--tr', txt: '❀' },
      { cls: 'mama-corner mama-corner--bl', txt: '❁' },
      { cls: 'mama-corner mama-corner--br', txt: '✾' }
    ];
    corners.forEach(function (c) {
      var corner = el('span', c.cls, c.txt);
      card.appendChild(corner);
    });

    modal.appendChild(card);
    // Модалка persistent — закривається тільки хрестиком або після застосування
    document.body.appendChild(modal);
  }

  function showModal() {
    if (!modal) createModal();
    modal.classList.remove('mama-modal--hidden');
    requestAnimationFrame(function () {
      modal.classList.add('mama-modal--visible');
    });
    if (quizDone) {
      showResult(score);
    } else {
      showWelcome();
    }
  }

  function hideModal() {
    modal.classList.remove('mama-modal--visible');
    setTimeout(function () { modal.classList.add('mama-modal--hidden'); }, 550);
  }

  // ─── Screens ────────────────────────────────────────────────
  function setScreen(html) {
    // Remove old screens
    var old = card.querySelector('.mama-screen--active, .mama-screen--entering');
    if (old) {
      old.classList.remove('mama-screen--active');
      old.classList.add('mama-screen--leaving');
      setTimeout(function () { if (old.parentNode) old.remove(); }, 550);
    }

    var screen = el('div', 'mama-screen mama-screen--entering');
    screen.innerHTML = html;
    card.appendChild(screen);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        screen.classList.remove('mama-screen--entering');
        screen.classList.add('mama-screen--active');
      });
    });

    return screen;
  }

  // ─── Welcome screen ────────────────────────────────────────
  function showWelcome() {
    var screen = setScreen(
      '<div class="mama-flower">✿</div>' +
      '<div class="mama-eyebrow">До Дня матері ми підготували невеличкий квіз ✿</div>' +
      '<h2 class="mama-title">Чи добре ти знаєш<br>свою маму?</h2>' +
      '<p class="mama-subtitle">Спробуй відповісти на 10 тверджень — і дізнайся, що ще можна запитати ✿"</p>' +
      '<button class="mama-cta" id="mama-start">Розпочати</button>' +
      '<p class="mama-note">Промокод отримають усі ✿</p>'
    );

    screen.querySelector('#mama-start').onclick = function () {
      currentQ = 0;
      score = 0;
      showQuestion();
    };
  }

  // ─── Question screen ───────────────────────────────────────
  function showQuestion() {
    var progressHtml = '<div class="mama-progress">';
    for (var i = 0; i < QUESTIONS.length; i++) {
      var dotClass = 'mama-progress__dot';
      if (i < currentQ) dotClass += ' mama-progress__dot--done';
      else if (i === currentQ) dotClass += ' mama-progress__dot--current';
      progressHtml += '<div class="' + dotClass + '"></div>';
    }
    progressHtml += '</div>';

    var screen = setScreen(
      progressHtml +
      '<div class="mama-question">' +
        '<div class="mama-question__number">Питання ' + (currentQ + 1) + ' з ' + QUESTIONS.length + '</div>' +
        '<div class="mama-question__text">' + QUESTIONS[currentQ] + '</div>' +
        '<div class="mama-question__buttons">' +
          '<button class="mama-question__btn mama-question__btn--yes" id="mama-yes">Знаю</button>' +
          '<button class="mama-question__btn mama-question__btn--no" id="mama-no">Не знаю</button>' +
        '</div>' +
      '</div>'
    );

    screen.querySelector('#mama-yes').onclick = function () { answer(true); };
    screen.querySelector('#mama-no').onclick = function () { answer(false); };
  }

  function answer(yes) {
    if (yes) score++;
    currentQ++;
    if (currentQ < QUESTIONS.length) {
      showQuestion();
    } else {
      quizDone = true;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ done: true, score: score })); } catch (e) {}
      showResult(score);
    }
  }

  // ─── Result screen ─────────────────────────────────────────
  function showResult(s) {
    var tier = getTier(s);
    var reminder = REMINDERS[Math.floor(Math.random() * REMINDERS.length)];

    var screen = setScreen(
      '<div class="mama-flower">❀</div>' +
      '<div class="mama-result__score">' + s + '</div>' +
      '<div class="mama-result__of">з ' + QUESTIONS.length + '</div>' +
      '<p class="mama-result__message">' + tier.message + '</p>' +
      '<div class="mama-result__divider"></div>' +
      '<p class="mama-result__gift-line">Дякуємо за проходження квізу 💛<br>Тримай знижку від нас на честь свята</p>' +
      '<div class="mama-result__promo-label">' + tier.discount + ' · ' + PROMO_DATES + '</div>' +
      '<button class="mama-cta" id="mama-apply">Застосувати до кошика</button>' +
      '<p class="mama-result__reminder">' + reminder + '</p>' +
      ''
    );

    screen.querySelector('#mama-apply').onclick = function () {
      var btn = this;
      btn.textContent = 'Застосовується…';
      btn.disabled = true;
      btn.style.opacity = '0.7';
      // Спершу скидаємо старий промокод, потім застосовуємо новий
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).then(function () {
        return fetch('/discount/' + encodeURIComponent(tier.code), {
          credentials: 'same-origin',
          method: 'GET'
        });
      }).then(function () {
        btn.textContent = 'Застосовано ✓';
        btn.style.opacity = '1';
        setTimeout(function () {
          hideModal();
          location.reload();
        }, 800);
      }).catch(function () {
        btn.textContent = 'Застосувати до кошика';
        btn.disabled = false;
        btn.style.opacity = '1';
      });
    };

  }

  // ─── Trigger button ─────────────────────────────────────────
  function createTrigger() {
    var btn = el('button', 'mama-trigger', '✿ Квіз до Дня матері');
    btn.onclick = showModal;
    document.body.appendChild(btn);
  }

  // ─── Init ───────────────────────────────────────────────────
  function init() {
    createTrigger();

    // Автопоказ при першому заході (як пасхальна гра)
    var seen = false;
    try { seen = !!localStorage.getItem(STORAGE_KEY + '_seen'); } catch (e) {}
    if (!seen && !quizDone) {
      setTimeout(showModal, 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
